import { render, staticRenderFns } from "./training_record.vue?vue&type=template&id=4c775827&"
import script from "./training_record.vue?vue&type=script&lang=js&"
export * from "./training_record.vue?vue&type=script&lang=js&"
import style0 from "./training_record.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports